import { render, staticRenderFns } from "./outstream.vue?vue&type=template&id=b8d9c4dc&scoped=true&"
import script from "./outstream.vue?vue&type=script&lang=js&"
export * from "./outstream.vue?vue&type=script&lang=js&"
import style0 from "./outstream.vue?vue&type=style&index=0&id=b8d9c4dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d9c4dc",
  null
  
)

export default component.exports